import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSupplierAuth } from '../context/SupplierAuthContext';

function SupplierProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useSupplierAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Verifying authentication...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated()) {
    // Redirect to supplier login with return URL
    return <Navigate to="/supplier/login" state={{ from: location }} replace />;
  }

  return children;
}

export default SupplierProtectedRoute;
